import React from "react";

const LayoutContainer: React.FC<{ className?: string }> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`px-4 sm:px-8 md:px-12 w-full ${className}`}>
      {children}
    </div>
  );
};

export default LayoutContainer;
